export { default, type IProps } from "./NumberInput";
